import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Skeleton from '../../../componentsv2/Skeleton';
import Layout from '../../../componentsv2/Layout';

export default function BankingPageAccountDetailSkeleton() {
  return (
    <Layout>
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <Skeleton variant="rectangular" width={200} height={40} animation="wave" />
        </Grid>
        <Grid item xs={4} sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
          <Box>
            <Skeleton variant="rectangular" width={150} height="40px" animation="wave" />
          </Box>
        </Grid>

        {/* Balance Card */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              padding: '1.5em',
              height: '100%',
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Skeleton variant="text" width="60%" height={24} animation="wave" />
              </Grid>
              <Grid item xs={12}>
                <Skeleton variant="rectangular" width="100%" height={48} animation="wave" />
              </Grid>
              <Grid item xs={6}>
                <Skeleton variant="text" width="80%" height={20} animation="wave" />
                <Skeleton variant="text" width="100%" height={24} animation="wave" />
              </Grid>
              <Grid item xs={6}>
                <Skeleton variant="text" width="80%" height={20} animation="wave" />
                <Skeleton variant="text" width="100%" height={24} animation="wave" />
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Account Details Card */}
        <Grid item xs={12} md={8}>
          <Box
            sx={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              padding: '1.5em',
              height: '100%',
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Skeleton variant="text" width="40%" height={20} animation="wave" />
                    <Skeleton variant="text" width="100%" height={24} animation="wave" />
                  </Grid>
                  <Grid item xs={4}>
                    <Skeleton variant="text" width="40%" height={20} animation="wave" />
                    <Skeleton variant="text" width="100%" height={24} animation="wave" />
                  </Grid>
                  <Grid item xs={4}>
                    <Skeleton variant="text" width="40%" height={20} animation="wave" />
                    <Skeleton variant="text" width="100%" height={24} animation="wave" />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Skeleton variant="rectangular" width={180} height={36} animation="wave" />
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Recent Transactions */}
        <Grid item xs={12}>
          <Box
            sx={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              padding: '1.5em',
            }}
          >
            <Grid container spacing={3}>
              <Grid
                item
                xs={12}
                sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Skeleton variant="text" width={200} height={32} animation="wave" />
                <Skeleton variant="text" width={100} height={32} animation="wave" />
              </Grid>

              {/* Table Header */}
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {['15%', '30%', '15%', '15%', '15%'].map((width, index) => (
                    <Grid item xs key={index}>
                      <Skeleton variant="text" width={width} height={24} animation="wave" />
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              {/* Table Rows */}
              {[1, 2, 3, 4, 5].map((row) => (
                <Grid item xs={12} key={row}>
                  <Grid container spacing={2}>
                    {['15%', '30%', '15%', '15%', '15%'].map((width, index) => (
                      <Grid item xs key={index}>
                        <Skeleton variant="text" width={width} height={24} animation="wave" />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Layout>
  );
}
